import logo from '../assets/images/logo.svg';
import { Card } from 'react-bootstrap';
import Image from '../components/common/Image';

const Maintenance = () => {
    return (
        <div className="container-fluid okc">
            <div className="row">
                <div className="col-12 col-lg-6 m-auto">
                    <div className="auth d-flex align-items-center justify-content-center">
                        <div className="auth-inner p-0">
                            <Card className="maintenance-card">
                                <div className="auth__logo fade-in mb-0">
                                    <Image alt="logo" height={100} src={logo} width={200} />
                                </div>
                                <div className="auth__error text-center fade-in">
                                    <div className="maintenance-text01">メンテナンス中です。</div>
                                    <div className="maintenance-text02">時間を空けてアクセスください。</div>
                                </div>
                            </Card>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Maintenance;
